<template>
  <v-form v-model="businessAddress" ref="form">
    <v-row>
      <v-col cols="12" md="4">
        <v-select
          label="استان *"
          v-model="stateId"
          outlined
          item-text="value"
          item-value="id"
          dense
          required
          :rules="[(v) => !!v || 'وارد کردن مقدار الزامی میباشد']"
          :items="provinceList"
          @change="getCitys()"
          :disabled="
            merchantIsApproved && !merchantMonitorFields.CityId ? true : false
          "
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          required
          :rules="[(v) => !!v || 'وارد کردن مقدار الزامی میباشد']"
          label="شهرستان *"
          hint="ابتدا استان خود را انتخاب کنید"
          persistent-hint
          v-model="form.address.cityId"
          outlined
          item-text="value"
          item-value="id"
          dense
          :items="cityList"
          @change="getUrbanareasByCity()"
          :disabled="
            merchantIsApproved && !merchantMonitorFields.CityId ? true : false
          "
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          :items="industrialParksItems"
          item-text="name"
          item-value="id"
          v-model="form.address.industrialParkId"
          :disabled="
            form.address.cityId == '' ||
            (merchantIsApproved && !merchantMonitorFields.IndustrialParkId)
              ? true
              : false
          "
          dense
          outlined
          label="شهرک صنعتی"
          placeholder="ابتدا استان و شهرستان را انتخاب کنید"
        >
        </v-select>
      </v-col>
      <v-col cols="12">
        <v-text-field
          required
         :rules="[
          v => !!v || 'ثبت اطلاعات تکمیلی آدرس الزامی‌است.',
          v => (v && v.length <= 100 && v.length>=3) || 'اطلاعات تکمیلی آدرس حداقل ۳ کاراکتر باید باشد',
             
          ]"
          label="اطلاعات تکمیلی آدرس *"
          placeholder="محله، خیابان و کوچه"
          v-model="form.address.addressLane"
          type="text"
          outlined
          dense
          :disabled="
            merchantIsApproved && !merchantMonitorFields.AddressLane
              ? true
              : false
          "
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          required
          :rules="[(v) => !!v || 'وارد کردن مقدار الزامی میباشد']"
          label="پلاک *"
          v-model="form.address.no"
          type="number"
          outlined
          dense
          :disabled="
            merchantIsApproved && !merchantMonitorFields.No ? true : false
          "
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
          label="واحد"
          v-model="form.address.unit"
          type="number"
          outlined
          dense
          :disabled="
            merchantIsApproved && !merchantMonitorFields.Unit ? true : false
          "
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-text-field
           
          :rules="[
            (v) => {
              
               if (v && !/^(\d{10,10})+$/.test(v)) {
                return 'کد پستی حتما باید عدد و 10 رقم باشد';
              } else return true;
            },
          ]"
          label="کد پستی "
          v-model="form.address.postalCode"
          type="number"
          outlined
          dense
          counter="10"
          :disabled="
            merchantIsApproved && !merchantMonitorFields.PostalCode
              ? true
              : false
          "
        />
      </v-col>

      <v-col cols="12">
        <div class="text-secondary">موقعیت جغرافیایی (اختیاری)</div>
        <div>
          <span>
            برای انتخاب موقعیت جاری خود روی دگمه
            <v-icon>mdi-crosshairs-gps</v-icon> کلیک کنید، یا از قسمت جستجو،
            مکان مورد نظر را تایپ کرده و از لیست پیشنهادی یک مورد را انتخاب
            کنید</span
          >
          <span>یا  روی نقشه در موقعیت مورد نظر کلیک کنید.</span>
        </div>
        <v-col md="6" sm="12">
          <v-autocomplete
            v-model.lazy="mapSearchValue"
            :items="mapSearchItems"
            :loading="mapSearchLoading"
            :search-input.sync="handleMapSearch"
            outlined
            item-text="title"
            return-object
            prepend-inner-icon="mdi-map-marker"
            label="جستــجو"
            hide-no-data
            placeholder="مکان مورد نظر خود را وارد کنید"
          >
            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title>
                  {{ data.item.title }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ data.item.region }}
                </v-list-item-subtitle>
                <v-list-item-subtitle>
                  {{ data.item.address }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>
        <l-map
          ref="myMap"
          :zoom="zoom"
          :center="center"
          style="width: 100%; height: 250px"
          @click="addMarkerAddr"
          @fullscreenchange="handleFullScreenChange"
          @update:center="centerUpdated"
        >
          <l-control-fullscreen
            position="topleft"
            :options="{
              title: { false: 'Go big!', true: 'Be regular' },
            }"
          />
          <l-tile-layer :url="url" />
          <l-marker
            v-for="(item, index) in marker"
            :key="index"
            :lat-lng="item"
          >
            <l-icon
              :icon-size="[40, 40]"
              :icon-anchor="[20, 40]"
              :icon-url="path"
            >
            </l-icon>
          </l-marker>
        </l-map>
        <v-btn
          @click="currentLocationButton"
          id="currentLocationButton"
          color="info"
          fab
          small
          dark
        >
          <v-icon>mdi-crosshairs-gps</v-icon>
        </v-btn>
        <v-btn
          @click="goToMarkPlace"
          id="refreshButton"
          color="primary"
          fab
          small
          dark
        >
          <v-icon>mdi-map-marker-question </v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
import Helper from '@/core/helpers';
import { mapGetters } from 'vuex';
const merchantRepository = () => RepoFactory.get('merchant');
const urbanAreasRepository = () => RepoFactory.get('urbanAreas');
const industrialParksRepository = () => RepoFactory.get('industrialParks');

export default {
  props: {
    validateBusinessAddress: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    businessRegistrationData: {
      type: Object,
      default: null,
    },
    merchantIsApproved: {
      type: Boolean,
      default: false,
    },
    merchantMonitorFields: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      businessAddress: true,
      zoom: 5,
      path: '/media/map/pin.svg',
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      marker: [],
      center: [35.738018, 51.404314],
      stateId: null,
      urbanareasList: [],
      provinceList: [],
      neighbourhood: null,
      cityList: [],
      industrialParksItems: [],
      urbanareasList: [],
      handleMapSearch: null,
      mapSearchLoading: false,
      mapSearchItems: [],
      mapSearchValue: '',
      form: {
        address: {
          title: 'آدرس ثبت شده در فرایند ثبت نام',
          cityId: null,
          neighbourhoodId: null,
          addressLane: null,
          postalCode: null,
          no: null,
          unit: null,
          latitude: null,
          longitude: null,
        },
      },
    };
  },

  computed: {
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
    ...mapGetters(['neshanApiKey']),
  },
  created() {
    this.resize();
    this.getProvinceList();
    if (this.isEdit && this.businessRegistrationData?.address) {
      this.fillValue(this.businessRegistrationData);
    }
  },
  watch: {
    stateId() {
      if (this.stateId != null && this.stateId != '') {
        this.getIndustrialParksItems();
      }
    },
    validateBusinessAddress(aft, bef) {
      if (aft) {
        if (this.$refs.form.validate()) {
          this.$emit('nextStep', this.form, 'businessAddress');
        } else {
          this.$emit('validationFailed');
        }
      }
    },
    mapSearchValue(val) {
      if (val) {
        this.form.address.latitude = val.location.y;
        this.form.address.longitude = val.location.x;
        let latlng = { lat: val.location.y, lng: val.location.x };
        this.marker = [];

        this.marker.push(latlng);
        this.$refs.myMap.mapObject.flyTo(latlng, 15);
      }
    },
    handleMapSearch(val) {
      let app = this;
      // Items have already been loaded
      if (this.mapSearchItems?.length > 30) return;

      // Items have already been requested
      if (this.mapSearchLoading) return;

      if (!val) {
        this.mapSearchItems = [];
      }
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        if (val.length > 1) {
          this.mapSearchLoading = true;
          this.mapSearchItems = [];
          fetch(
            `https://api.neshan.org/v1/search?term=${val}&lat=${this.center[0]}&lng=${this.center[1]}`,
            {
              headers: {
                'Api-Key': app.neshanApiKey,
              },
            }
          )
            .then((res) => res.json())
            .then((res) => {
              if (res.code && res.code > 400) alert(res.message);
              const { count, items } = res;
              this.mapSearchItems = [];
              this.mapSearchItems = items;
            })
            .catch((err) => {})
            .finally(() => (this.mapSearchLoading = false));
        }
      }, 1000);
    },
  },
  mounted() {
    this.resize();
  },
  methods: {
    fillValue(data) {
      this.stateId = data.address.stateId;
      this.form = {
        address: {
          title: data.address.title ? data.address.title : 'اطلاعات آدرس',
          cityId: data.address.cityId,
          neighbourhoodId: data.address.neighbourhoodId,
          addressLane: data.address.addressLane,
          postalCode: data.address.postalCode,
          no: data.address.no,
          unit: data.address.unit,
          latitude: data.address.latitude,
          longitude: data.address.longitude,
        },
      };
      if (data.address.stateId) {
        this.getCitys();
      }
      if (this.form.address.cityId) {
        this.getUrbanareasByCity();
      }
      if (data && data.address?.latitude) {
        this.zoom = 6;
        this.marker.push({
          lat: data.address.latitude,
          lng: data.address.longitude,
        });
        this.center = [data.address.latitude, data.address.longitude];
      }
    },
    resize() {
      setTimeout(function () {
        window.dispatchEvent(new Event('resize'));
      }, 250);
    },
    currentLocationButton() {
      let app = this;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          app.marker = [];
          let latlng = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          app.form.address.latitude = position.coords.latitude;
          app.form.address.longitude = position.coords.longitude;
          app.marker.push(latlng);
          app.$refs.myMap.mapObject.flyTo(latlng, 15);
        });
      } else {
        alert('موقعیت یاب در این مرورگر پشتیبانی نمیشود');
      }
    },
    goToMarkPlace() {
      this.$refs.myMap.mapObject.flyTo(this.marker[0], 15);
    },

    getCitys() {
      this.neighbourhood = null;
      this.urbanareasList = [];
      const params = {
        stateId: this.stateId,
        cityType: 'City',
      };
      merchantRepository()
        .getCitiesByState(this.merchantBaseUrl, params)
        .then((res) => {
          this.cityList = res.data;
          this.loaded = true;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        });
    },
    getIndustrialParksItems() {
      let params = { stateId: this.stateId };
      industrialParksRepository()
        .getDataByCityId(this.merchantBaseUrl, {}, params)
        .then((res) => {
          this.industrialParksItems = res.data;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        });
    },
    handleFullScreenChange() {
      this.$refs.myMap.mapObject.panTo([
        this.form.address.latitude,
        this.form.address.longitude,
      ]);
    },
    centerUpdated(event) {
      if (event.lat && event.lng) {
        this.center = [event.lat, event.lng];
      }
    },
    getUrbanareasByCity() {
      this.neighbourhood = null;
      this.urbanareasList = [];

      urbanAreasRepository()
        .filterUrbanAreasByCity(this.merchantBaseUrl, {
          cityId: this.form.address.cityId,
        })
        .then((res) => {
          this.urbanareasList = res.data;
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        });
    },
    addMarkerAddr(event) {
      this.form.address.latitude = event.latlng.lat;
      this.form.address.longitude = event.latlng.lng;
      this.marker = [];
      this.marker.push(event.latlng);
    },
    getProvinceList() {
      return new Promise((resolve, reject) => {
        merchantRepository()
          .getProvince(this.merchantBaseUrl)
          .then((res) => {
            this.provinceList = res.data;
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
</script>

<style></style>
